export default __webpack_public_path__ + "static/media/qr_code.0f854a58.svg";